import { z } from 'zod';
import {
  BaseProcessingScheduleSchema,
  ProcessingScheduleSchemaValidation,
} from '../ProcessingScheduleSchema';

export const AddDataSourceSchema = z
  .object({
    name: z.string().min(1, 'Name is required'),
    description: z.string().nullable().optional(),
    enabled: z.boolean(),
    customNotebookPath: z.string().optional(),
  })
  .merge(BaseProcessingScheduleSchema)
  .superRefine(...ProcessingScheduleSchemaValidation);

export type AddDataSourceSchemaFormValues = z.infer<typeof AddDataSourceSchema>;
